export const mapClientToTableData = (c) => {
    return {
        ...c,
        key: c.id,
        client: c.name,
        clientLogoUrl: "",
    };
};
